import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { limitCharacters } from '../modules/modules';
import logo from '../assets/logo.png';

const encodeShareUrl = (url) => encodeURIComponent(url);
const encodeShareText = (text) => encodeURIComponent(text);

export const AssetBox = ({ product }) => {
    const [shareOpen, setShareOpen] = useState(false);
    const [copySuccess, setCopySuccess] = useState(false);
    const shareRef = useRef(null);

    const shareUrl = typeof window !== 'undefined'
        ? `${window.location.origin}${window.location.pathname}#product-${product.id}`
        : '';
    const shareTitle = product.name || 'Product';
    const shareText = `${shareTitle} - ${product.price ? `${product.price} TZS` : ''}`.trim();

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (shareRef.current && !shareRef.current.contains(e.target)) {
                setShareOpen(false);
            }
        };
        if (shareOpen) {
            document.addEventListener('click', handleClickOutside);
        }
        return () => document.removeEventListener('click', handleClickOutside);
    }, [shareOpen]);

    const copyLink = async () => {
        try {
            await navigator.clipboard.writeText(`${shareText} ${shareUrl}`);
            setCopySuccess(true);
            setTimeout(() => setCopySuccess(false), 2000);
            setShareOpen(false);
        } catch (err) {
            console.warn('Copy failed:', err);
        }
    };

    const nativeShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: shareTitle,
                    text: shareText,
                    url: shareUrl,
                    thumbnail: product.coverImage || logo
                });
                setShareOpen(false);
            } catch (err) {
                if (err.name !== 'AbortError') console.warn('Share failed:', err);
            }
        }
    };

    const hasNativeShare = typeof navigator !== 'undefined' && navigator.share;
    
    return (
        <a href={`/product/${product.id}/${encodeURIComponent(product.name)}/${encodeURIComponent(product.desc)}/${encodeURIComponent(product.coverImage)}/`} style={{"textDecoration":"none"}}>
        <article className="asset-box" style={{overflow:'auto', scrollbarWidth:"none"}}>
            <div className="asset-box__image-wrap">
                <img src={product.coverImage || logo} alt={product.name} />
            </div>
            <div className="asset-box__body">
                <p className="asset-box__description">{limitCharacters(product.description, 40)}</p>
                {
                    product.color && (
                        <small className="asset-box__color"><span style={{color: "#F9A825"}}>color</span>: {product.color}</small>
                    )
                }
                {product.size && (
                    <small className="asset-box__color"><span style={{color: "#F9A825"}}>size</span>: {product.size}</small>
                )}

                <div className="asset-box__footer">
                    <small className="asset-box__price">{limitCharacters(product.name, 10)}</small>
                    <div className="share-wrapper" ref={shareRef}>
                        <button
                            className="share-button"
                            aria-label="Share"
                            aria-expanded={shareOpen}
                            aria-haspopup="true"
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                nativeShare();
                            }}
                            type="button"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="18" cy="5" r="3"></circle>
                                <circle cx="6" cy="12" r="3"></circle>
                                <circle cx="18" cy="19" r="3"></circle>
                                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                            </svg>
                        </button>
                        {/* {shareOpen && (
                            <div className="share-dropdown" role="menu">
                                {hasNativeShare && (
                                    <button type="button" className="share-dropdown__item" onClick={nativeShare} role="menuitem">
                                        <span className="share-dropdown__icon">⎘</span> Share to...
                                    </button>
                                )}
                                {/* <button type="button" className="share-dropdown__item" onClick={shareToWhatsApp} role="menuitem">WhatsApp</button>
                                <button type="button" className="share-dropdown__item" onClick={shareToFacebook} role="menuitem">Facebook</button>
                                <button type="button" className="share-dropdown__item" onClick={shareToTwitter} role="menuitem">X (Twitter)</button>
                                <button type="button" className="share-dropdown__item" onClick={shareToTelegram} role="menuitem">Telegram</button> 
                                <button type="button" className="share-dropdown__item" onClick={copyLink} role="menuitem">
                                    {copySuccess ? '✓ Copied!' : 'Copy link'}
                                </button>
                            </div>
                        )} */}
                    </div>
                </div>

                {
                    product.onPromotion ===true ?
                    <span className="init-price">{Number(product.promotionPrice).toLocaleString()} tsh</span>
                    :
                    <span className="init-price">{Number(product.price).toLocaleString()} tsh</span>
                    
                }

                
            </div>
        </article>
        </a>
    );
};




// /:name/:desc/:coverImg/
// }/${product.name}/${product.description}/${product.coverImage}}

